import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_85du58x7ja: FaireBrandEntity = {
  token: "b_85du58x7ja",
  type: "brand",
  name: "La Jolie Muse",
  avatarUrl:
    "https://cdn.faire.com/fastly/d1f7d1687374eed806e69c87faab560f46f01351bb8857bd110c2a75e23b4d3d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3d79861ba1748bd70643ac7a65b9c3afc6c625e1cb5804a82c4e9fa34e9dbb96.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d1f7d1687374eed806e69c87faab560f46f01351bb8857bd110c2a75e23b4d3d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3d79861ba1748bd70643ac7a65b9c3afc6c625e1cb5804a82c4e9fa34e9dbb96.jpeg",
  location: "Chino Hills, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 64,
  isInsider: true,
  description:
    "La Jolie Muse was founded to transform personal spaces into realms of aromatic luxury and artistic elegance. Born from a passion for nature's purest gifts and a flair for artistic expression, our journey is as enchanting as the scents we create. ",
  meta: {
    source: "api",
    importedAt: "2026-09-17T19:42:26.736Z",
    importedBy: "entity-db-cli",
  },
};
